import React from 'react';
import NinjaGame from '../NinjaGame';
import { ALL_DRILLS } from '../DrillConstants';

const ThreeYardReload = () => {
    const idx = ALL_DRILLS.findIndex(d => d.id === '3y-reload');
    return <NinjaGame initialDrillIndex={idx} />;
};

export default ThreeYardReload;
